export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/ke.4314b09b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};